import React, {Fragment,Component} from "react";
import axios from "axios";
import exportToExcel from "../utils/ExcelUtils";

class PolicyInforcedRow extends Component{
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            apiDetail: '/api/bankportal/report/detail/inforced',
            reportName: 'ReportInforced',
        }
        this.onCLickToExport = this.onCLickToExport.bind(this);
        this.exportToExcel = exportToExcel.bind(this);
        this.handlerClickNode = this.props.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }
    onCLickToExport = (item) => {
        const payload = {
            yyyymmdd: item?.yyyymmdd,
            code: item?.code,
            type: item?.type,
            parentId: item?.parentId
        }
        const { apiDetail, reportName } = this.state;
        this.handlerSetIsLoading(true);
        axios.post(apiDetail, payload)
            .then(response => {
                let data = [];
                if(!!response.data){
                    data.push([
                        "Ngày báo cáo"
                        ,"Mã chi nhánh (FWD)"
                        ,"Mã chi nhánh (Ngân hàng)"
                        ,"Tên chi nhánh"
                        ,"Mã phòng giao dịch (FWD)"
                        ,"Mã phòng giao dịch (Ngân hàng)"
                        ,"Tên phòng giao dịch"
                        ,"Mã NVNH"
                        ,"Mã CBNV"
                        ,"Tên NVNH"
                        ,"Số hợp đồng"
                        ,"Loại hợp đồng"
                        ,"Tên sản phẩm"
                        ,"Mã sản phẩm"
                        ,"Loại sản phẩm"
                        ,"Tình trạng HĐBH"
                        ,"Thời hạn hợp đồng"
                        ,"Tên chủ hợp đồng"
                        ,"CMND/ Passport"
                        ,"Tên người được bảo hiểm"
                        ,"Ngày phát hành"
                        ,"Ngày tái phát hành"
                        ,"Ngày đến hạn đóng phí"
                        ,"Định kỳ đóng phí"
                        ,"Số tiền bảo hiểm"
                        ,"Số phí đóng của 1 định kỳ"
                        ,"Phí thực thu trong tháng"
                        ,"Mã FSC"
                        ,"Tên FSC"
                        ,"Mã miền"
                        ,"Tên miền"
                        ,"CBNV Ngân hàng"
                    ]);
                    response?.data.map(item =>
                        data.push([
                            item?.reportDate
                            ,item?.boCode
                            ,item?.boCodeBank
                            ,item?.boName
                            ,item?.toCode
                            ,item?.toCodeBank
                            ,item?.toName
                            ,item?.bsCode
                            ,item?.bsCodeBank
                            ,item?.bsName
                            ,item?.policyNumber
                            ,item?.clientType
                            ,item?.productName
                            ,item?.productCode
                            ,item?.productType
                            ,item?.statusName
                            ,item?.policyTerm
                            ,item?.poName
                            ,item?.poId
                            ,item?.laName
                            ,item?.firstIssueDate
                            ,item?.issueDate
                            ,item?.paidToDate
                            ,item?.premiumMode
                            ,item?.sa
                            ,item?.ip
                            ,item?.fyp
                            ,item?.fscCode
                            ,item?.fscName
                            ,item?.regionCode
                            ,item?.regionName
                            ,item?.bsSell
                        ])
                    )
                }

                const exportName = item?.yyyymmdd+'_'+item?.code+'_'+item?.name+'_'+reportName;
                this.exportToExcel(data, exportName);
                this.handlerSetIsLoading(false);
            })
            .catch(error => {
                this.setState({ errorMessage: error.message });
                console.error('There was an error!', error);
                this.handlerSetIsLoading(false);
            });
    }
    render() {
        const {hasChild,isExpanded,marginLeftValue,data} = this.props;
        const iconStyle = {
            marginLeft: marginLeftValue+'px',
            boxShadow: 'none'
        }
        return (
            <Fragment>
            {
                !!data &&
                    <tr>
                        <td className={'bp-report-tree-node'}>
                            <button style={iconStyle} type="button" className={"btn"} onClick={this.handlerClickNode}>
                                {
                                    hasChild ?isExpanded?(' - '):(' + '):('   ')
                                }
                            </button>
                            <span>{ data?.name }</span>
                        </td>
                        <td className={"bp-report-td"}><span> { data?.c_inforced?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_inforced?.toLocaleString() } </span></td>
                        <td className={'bp-report-button-export'}>
                            <button onClick={ () => this.onCLickToExport(data) } className={"btn btn-sm btn-info mt-1"}>Chi tiết</button>
                        </td>
                    </tr>

            }
            </Fragment>
        )
    }
}
export default PolicyInforcedRow;